/*
  全部页面引入
 */

// import Base from "./Base";
import SupplierType from "./SupplierType";
import SupplierList from "./SupplierList";
import GoodsType from "./GoodsType";
import GoodsList from "./GoodsList.vue";
import StockManage from "./StockManage.vue";

const pages = {
  SupplierType,
  SupplierList,
  GoodsType,
  GoodsList,
  StockManage
};
export default pages;
